<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Custom styles for site navigation -->
<style>
    /* Prevent horizontal scroll on mobile */
    html,
    body {
        /* clip (not hidden) prevents horizontal overflow WITHOUT creating a
           scroll container, so position:sticky descendants (e.g. inventory sidebar) work. */
        overflow-x: clip !important;
        width: 100%;
        margin: 0;
        padding: 0;
    }

    .site-header {
        font-family: inherit;
    }

    .site-header__secondary-link,
    .site-header__primary-link {
        letter-spacing: 0.08em;
        transition: color 0.2s ease, font-weight 0.2s ease;
    }

    /* Top utility links (DEALERS / FAQ / CONTACT) */
    .site-header__secondary-link {
        color: #FFFFFF;
    }

    /* Main menu links */
    .site-header__primary-link {
        color: #A2A2A2;
    }

    .site-header__secondary-link:hover,
    .site-header__primary-link:hover {
        color: #ffffff;
    }

    .site-header__primary-link--active,
    .site-header__secondary-link--active {
        font-weight: 700;
        color: #ffffff;
    }

    /* Dealer hotline stays white regardless of the inactive menu colour */
    .site-header__phone,
    .site-header__phone:hover {
        color: #ffffff;
    }

    .site-header__cta {
        background-color: #95080B;
        letter-spacing: 0.08em;
    }

    .site-header__cta:hover {
        background-color: #b30a0e;
    }

    .site-header__about-menu.mat-mdc-menu-panel {
        background-color: rgba(0, 0, 0, 0.95) !important;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px !important;
        margin-top: 8px;
    }

    .site-header__about-menu .mat-mdc-menu-item {
        color: white !important;
        min-height: 40px;
    }

    .site-header__about-menu .mat-mdc-menu-item:hover {
        background-color: rgba(149, 8, 11, 0.25) !important;
    }

    .site-header__logo {
        line-height: 1;
    }

    .site-header__slogan {
        letter-spacing: 0.28em;
    }
</style>

<!-- Mobile Backdrop Overlay - Browser Only -->
@if (isBrowser && sidebarOpen && isScreenSmall) {
<div class="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" (click)="toggleSidebar()">
</div>
}

<!-- Mobile Sidebar - Browser Only (skip during SSR to avoid icon errors) -->
@if (isBrowser && isScreenSmall) {
<ng-container>
    <div [ngClass]="{
      'translate-x-0': sidebarOpen,
      '-translate-x-full': !sidebarOpen,
      'w-60': sidebarOpen
    }" class="sidebar-container fixed top-0 left-0 h-screen shadow-xl flex flex-col z-[60] transition-all duration-300 backdrop-blur-md bg-black/90 !font-inter"
        style="max-height: 100vh; max-height: 100dvh;">

        <nav class="flex flex-col text-white flex-1 mt-4 overflow-y-auto min-h-0"
            style="-webkit-overflow-scrolling: touch; overscroll-behavior-y: contain;">
            <div class="flex flex-col space-y-2 pb-20">
                <div class="flex items-center justify-end px-4">
                    <button (click)="toggleSidebar()" class="p-2 rounded group">
                        <mat-icon class="text-white">close</mat-icon>
                    </button>
                </div>
                <div class="flex flex-col gap-1 px-4 pb-3 mb-2 border-b border-white/10">
                    <a [href]="dealerPhoneHref" (click)="onHeaderPhoneClick()"
                        class="flex items-center gap-2 text-sm uppercase tracking-wide text-white hover:text-primary py-2">
                        <mat-icon class="text-white icon-size-4" [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                        {{ dealerPhone }}
                    </a>
                </div>
                @for (item of sidebarItems; track item.page) {
                <!-- Collapsible Menu Item -->
                @if (item.type === 'collapsable' && item.children) {
                <!-- Parent Item -->
                <button
                    class="group relative px-3 mx-2 py-2 h-10 transition-colors flex items-center justify-between w-full"
                    [ngClass]="{'text-primary-600': isCollapsibleItemActive(item)}"
                    (click)="toggleCollapsibleItem(item)">
                    <div class="flex items-center">
                        @if (isCollapsibleItemActive(item)) {
                        <span class="absolute left-0 top-1 bottom-1 w-1 bg-primary-600 rounded-r"></span>
                        }
                        <mat-icon class="text-lg text-white hover:text-primary-600 mr-3"
                            [svgIcon]="item.icon"></mat-icon>
                        <span class="hover:text-primary-600">{{ item.label }}</span>
                    </div>
                    <!-- Expand/Collapse Icon -->
                    <mat-icon class="text-white transition-transform duration-200"
                        [ngClass]="item.isExpanded ? 'rotate-180' : ''">
                        expand_more
                    </mat-icon>
                </button>

                <!-- Children Items (Collapsible) -->
                @if (item.isExpanded && item.children) {
                <div class="ml-6 border-l border-gray-600">
                    @for (childItem of item.children; track childItem.page) {
                    <button
                        class="group relative px-3 mx-2 py-2 h-8 transition-colors flex items-center justify-start w-full"
                        [ngClass]="{'text-primary-600': activePage === childItem.page}"
                        (click)="navigateToChild(childItem, item)">
                        @if (activePage === childItem.page) {
                        <span class="absolute left-2 top-1 bottom-1 w-1 bg-primary-600 rounded-r"></span>
                        }
                        <span class="hover:text-primary-600 text-sm ml-2">{{ childItem.label }}</span>
                    </button>
                    }
                </div>
                }
                } @else {
                <!-- Basic Menu Item -->
                <button class="group relative px-3 mx-2 py-2 h-10 transition-colors flex items-center justify-start text-white"
                    (click)="onNavLinkClick(item.route, 'mobile_sidebar'); setActive(item.page); sidebarOpen = false; _router.navigate([item.route])">
                    @if (activePage === item.page) {
                    <span class="absolute left-0 top-1 bottom-1 w-1 bg-primary-600 rounded-r"></span>
                    }
                    <mat-icon class="text-lg text-white hover:text-primary-600 mr-3" [svgIcon]="item.icon"></mat-icon>
                    <span class="hover:text-primary-600">{{ item.label }}</span>
                </button>
                }
                }
            </div>
        </nav>
    </div>
</ng-container>
}

<!-- Shared site header navigation -->
<ng-template #siteHeaderNav>
    @if (isScreenSmall) {
    <div class="relative flex items-center justify-between w-full h-[72px] px-4">
        @if (isBrowser) {
        <button mat-icon-button (click)="toggleSidebar()" class="text-white z-10">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'" class="text-white"></mat-icon>
        </button>
        }
        <div class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer flex flex-col items-center"
            (click)="_router.navigate(['/landing'])">
            <img src="images/logo/logo.webp" alt="Superformance Logo" class="h-10 md:h-12 w-auto opacity-100">
            @if (siteHeaderSlogan) {
            <span class="site-header__slogan text-[8px] tracking-[0.22em] uppercase text-white/85 mt-1 whitespace-nowrap">{{ siteHeaderSlogan }}</span>
            }
        </div>
    </div>
    } @else {
    <div class="site-header w-full text-white">
        <div class="hidden md:flex items-center justify-between border-b border-white px-4 md:px-8 xl:px-12 h-9 text-xs">
            <nav class="flex items-center gap-6 lg:gap-10">
                @for (link of secondaryNavLinks; track link.route) {
                <a [routerLink]="link.route" (click)="onNavLinkClick(link.route, 'header_secondary')"
                    class="site-header__secondary-link uppercase"
                    [class.site-header__secondary-link--active]="isNavLinkActive(link.route)">{{ link.label }}</a>
                }
            </nav>
            <a [href]="dealerPhoneHref" (click)="onHeaderPhoneClick()"
                class="site-header__secondary-link site-header__phone flex items-center gap-1.5 normal-case">
                <mat-icon class="icon-size-4 text-white" [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                {{ dealerPhone }}
            </a>
        </div>
        <div class="flex items-center w-full px-4 md:px-8 xl:px-12 py-4 gap-4 lg:gap-8">
            <div class="flex-shrink-0 cursor-pointer site-header__logo flex flex-col items-start justify-center"
                (click)="_router.navigate(['/landing'])">
                <img src="images/logo/logo.webp" alt="Superformance Logo" class="h-11 md:h-12 w-auto opacity-100">
                @if (siteHeaderSlogan) {
                <span class="site-header__slogan text-[9px] lg:text-[10px] uppercase text-white/90 mt-1 whitespace-nowrap">{{ siteHeaderSlogan }}</span>
                }
            </div>
            <nav class="flex flex-1 items-center justify-center gap-4 lg:gap-6 xl:gap-8 text-sm">
                @for (link of primaryNavLinks; track link.id) {
                @if (link.type !== 'collapsable' && link.route) {
                <a [routerLink]="link.route"
                    class="site-header__primary-link uppercase whitespace-nowrap"
                    [class.site-header__primary-link--active]="isNavLinkActive(link.route)">{{ link.label }}</a>
                }
                }
                <button type="button" [matMenuTriggerFor]="aboutMenu"
                    class="site-header__primary-link uppercase flex items-center gap-0.5 bg-transparent border-0 cursor-pointer p-0"
                    [class.site-header__primary-link--active]="isAboutUsActive()">
                    ABOUT US
                    <mat-icon class="icon-size-4">expand_more</mat-icon>
                </button>
                <mat-menu #aboutMenu="matMenu" class="site-header__about-menu">
                    @for (child of aboutUsChildren; track child.route) {
                    <a mat-menu-item [routerLink]="child.route"
                        [class.font-semibold]="isNavLinkActive(child.route)">{{ child.label }}</a>
                    }
                </mat-menu>
            </nav>
            <button type="button" (click)="navigateToInventory()"
                class="site-header__cta flex-shrink-0 text-white text-xs lg:text-sm font-semibold uppercase px-4 lg:px-5 py-2.5 rounded-lg transition-colors whitespace-nowrap">
                VIEW INVENTORY
            </button>
        </div>
    </div>
    }
</ng-template>

<!-- Navigation -->
<!-- @if (isScreenSmall) { -->

<!-- } -->

<!-- Wrapper -->
<!-- overflow-x-clip (not -hidden) prevents horizontal overflow WITHOUT creating a
     scroll container, so position:sticky descendants (e.g. inventory sidebar) work. -->
<div class="flex flex-col flex-auto items-center w-full min-w-0 dark:bg-card ml-0 overflow-x-clip">

    <!-- Landing Page Content -->
    @if (isLandingPage()) {
    <!-- Landing Page with Header Inside Video -->
    <div class="flex flex-col w-full bg-black text-white overflow-x-hidden"
        style="background: url('images/SPF BG.png'); background-size: cover;">
        <!-- Video Hero Section -->
        <section id="video-hero-section" class="relative w-screen overflow-hidden"
            style="height: 100vh; height: 100dvh;">
            <!-- Video -->
            <!-- Poster image - displays instantly while video loads, hides when video plays -->
            <img src="images/spf-video-frame.png" alt="" aria-hidden="true"
                fetchpriority="high" decoding="async"
                class="absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ease-in-out"
                [class.opacity-0]="isVideoReady" [class.opacity-100]="!isVideoReady">
            <video #bgVideo autoplay loop muted playsinline webkit-playsinline preload="auto"
                poster="images/spf-video-frame.png"
                [class.opacity-0]="!isVideoReady" [class.opacity-100]="isVideoReady" [attr.src]="videoElementSrc || null"
                class="absolute inset-0 w-full h-full object-cover ease-in-out"
                [ngClass]="{'transition-none': _videoWasPreviouslyLoaded, 'transition-opacity duration-300': !_videoWasPreviouslyLoaded}">
            </video>

            <!-- Gradient Overlay -->
            <div class="absolute inset-0 w-full h-full pointer-events-none"
                style="background: linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 30%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0) 100%)">
            </div>

            <!-- Header Inside Video Section — fixed + dark so it stays pinned like
                 every other page instead of scrolling away transparently. -->
            <div class="fixed top-0 left-0 right-0 z-50 w-full transition-all duration-300"
                [ngClass]="{
                    'bg-black shadow-lg': isHeaderScrolled,
                    'backdrop-blur-md bg-black/60': !isHeaderScrolled
                }">
                <ng-container *ngTemplateOutlet="siteHeaderNav"></ng-container>
            </div>

            <!-- Hero Content -->
            <div class="absolute inset-0 z-10 flex flex-col text-center items-center justify-center md:justify-end w-full text-white transition-opacity duration-1000 ease-in-out pt-[72px] md:pt-[104px]"
                [ngClass]="{
                    'px-4 ': isScreenSmall, 
                    'sm:px-6 lg:px-8 ': !isScreenSmall
                }" [class.opacity-0]="!showHeroContent" [class.opacity-100]="showHeroContent"
                [style]="isScreenSmall
                    ? 'padding-bottom: 2rem;'
                    : 'padding-bottom: max(5rem, env(safe-area-inset-bottom));'">
                @if (homeVideoMain) {
                <!-- Since 1994 Text -->
                <div class="text-base sm:text-lg md:text-2xl mb-3 md:mb-4 font-light tracking-wide">Since 1994</div>

                <!-- Country Flag -->
                @if (homeVideoMain.countryFlagImageUrl) {
                <div class="mb-3 md:mb-4 text-center">
                    <img [src]="homeVideoMain.countryFlagImageUrl"
                        [alt]="homeVideoMain.countryFlagImage?.alternativeText || 'Country Flag'"
                        class="h-auto w-12 sm:w-16 md:w-20 object-contain mx-auto">
                </div>
                }

                <!-- Title Image or Text -->
                @if (homeVideoMain.titleImageUrl) {
                <div class="mb-3 md:mb-4 lg:mb-6 text-center max-w-lg md:max-w-2xl mx-auto">
                    <img [src]="homeVideoMain.titleImageUrl"
                        [alt]="homeVideoMain.titleImage?.alternativeText || 'Title'"
                        class="h-auto w-full max-w-full object-contain">
                </div>
                } @else if (homeVideoMain.title) {
                <div class="text-white text-3xl sm:text-4xl md:text-5xl lg:text-7xl xl:text-8xl tracking-widest leading-tight uppercase mb-3 md:mb-4 lg:mb-6 text-center font-anton"
                    [innerHTML]="homeVideoMain.title">
                </div>
                }

                <!-- Description -->
                @if (homeVideoMain.description) {
                <h1
                    class="text-sm sm:text-base md:text-xl lg:text-2xl font-light mt-2 mb-4 md:mb-6 lg:mb-8 px-2 max-w-2xl mx-auto leading-relaxed">
                    {{ homeVideoMain.description }}
                </h1>
                }

                <!-- Action Buttons -->
                <div
                    class="flex flex-wrap gap-3 justify-center items-center mb-4 md:mb-6 w-full max-w-md md:max-w-none mx-auto">
                    <button (click)="navigateToVehicles()"
                        class="bg-primary text-white font-bold px-6 py-3 rounded-lg shadow-lg hover:bg-primary-300 transition text-xs sm:text-sm md:text-base tracking-wider uppercase w-[calc(50%-0.375rem)] md:w-auto">
                        EXPLORE COLLECTION
                    </button>
                    <button (click)="navigateToDealers()"
                        class="bg-white text-black font-bold px-6 py-3 rounded-lg shadow-lg hover:bg-gray-100 transition text-xs sm:text-sm md:text-base tracking-wider outline outline-1 outline-primary uppercase w-[calc(50%-0.375rem)] md:w-auto">
                        FIND A DEALER
                    </button>
                    <button (click)="navigateToInventory()"
                        class="bg-white text-black font-bold px-6 py-3 rounded-lg shadow-lg hover:bg-gray-100 transition text-xs sm:text-sm md:text-base tracking-wider outline outline-1 outline-primary uppercase w-auto md:w-auto">
                        VIEW INVENTORY
                    </button>
                </div>

                <!-- License Images -->
                @if (licenseSection && licenseSection.images && licenseSection.images.length > 0) {
                <div class="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4 mb-4 md:mb-6">
                    @for (image of licenseSection.images; track image.id) {
                    <img [src]="image.fullUrl" [alt]="image.alternativeText || 'License logo'"
                        class="h-6 sm:h-7 md:h-8 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity">
                    }
                </div>

                <!-- Down Arrow -->
                <div class="flex justify-center my-4 md:my-6 animate-bounce">
                    <svg class="w-8 h-8 md:w-10 md:h-10 text-white drop-shadow-lg" fill="none" stroke="currentColor"
                        viewBox="0 0 24 24" stroke-width="3">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"></path>
                    </svg>
                </div>
                }
                }
            </div>

            <!-- Video Controls - Fixed Bottom Right -->
            @if(isVideoSectionVisible){
            <div class="fixed bottom-3 right-3 md:bottom-4 md:right-4 z-50 flex flex-col gap-2">
                <button (click)="toggleVideoPlayback()"
                    class="bg-transparent hover:bg-white hover:bg-opacity-20 text-white rounded-lg p-2 md:p-3 transition-all duration-300 border-2 border-white backdrop-blur-sm">
                    <div class="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                        @if (isVideoPaused) {
                        <div
                            class="w-0 h-0 border-l-[7px] md:border-l-[8px] border-l-white border-t-[5px] md:border-t-[6px] border-t-transparent border-b-[5px] md:border-b-[6px] border-b-transparent ml-1">
                        </div>
                        } @else {
                        <div class="flex gap-1">
                            <div class="w-1.5 h-3.5 md:w-2 md:h-4 bg-white"></div>
                            <div class="w-1.5 h-3.5 md:w-2 md:h-4 bg-white"></div>
                        </div>
                        }
                    </div>
                </button>
                <button (click)="toggleVideoMute()"
                    class="bg-transparent hover:bg-white hover:bg-opacity-20 text-white rounded-lg p-2 md:p-3 transition-all duration-300 border-2 border-white backdrop-blur-sm">
                    <div class="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                        @if (isVideoMuted) {
                        <svg class="w-5 h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 24 24">
                            <path
                                d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" />
                        </svg>
                        } @else {
                        <svg class="w-5 h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 24 24">
                            <path
                                d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                        </svg>
                        }
                    </div>
                </button>
            </div>
            }
        </section>

        <!-- Vehicles Section -->
        <div class="bg-black border-t-primary border-t-4 overflow-x-hidden py-10"
            style="background: url('images/SPF BG.png'); background-size: cover;">
            <section class="relative w-full pb-3 md:pb-5 px-4 mt-10">
                <div class="max-w-7xl mx-auto text-center">
                    <p class="text-xl md:text-xl lg:text-2xl text-white uppercase tracking-wider">BEYOND OWNERSHIP</p>
                    <h1 class="text-4xl md:text-5xl lg:text-7xl xl:text-8xl uppercase tracking-widest font-anton">
                        <span class="text-white">CHOOSE YOUR</span>
                        <span class=""> LEGACY</span>
                    </h1>
                </div>
            </section>
            <section class="relative w-full pt-2 md:pt-4 pb-4 md:pb-8 px-4">
                <div class="max-w-7xl mx-auto">
                    <div class="flex flex-wrap justify-center gap-6 md:gap-8">
                        @for (model of vehicleModels(); track model.id) {
                        <div class="group cursor-pointer flex w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.5rem)] max-w-md hover:scale-105 transition-transform duration-300"
                            (click)="exploreVehicle(model)">
                            <div class="hover:border-primary transition-all duration-300 flex flex-col w-full">
                                <div class="relative overflow-hidden rounded-2xl bg-gray-900 aspect-[431/260]"
                                    style="transform: translateZ(0); backface-visibility: hidden;">
                                    @if(model?.imageUrl) {
                                    <img [src]="model.imageUrl" [width]="431" [height]="260" [alt]="model.name"
                                        loading="lazy" style="transform: translate3d(0,0,0);"
                                        class="w-full h-full object-cover object-center">
                                    }
                                </div>
                                <div class="p-4 md:p-6 text-center">
                                    <h3
                                        class="text-2xl md:text-3xl lg:text-5xl text-white uppercase tracking-wider font-anton min-h-[2.5rem] md:min-h-[3rem] lg:min-h-[3.5rem] flex items-center justify-center">
                                        {{ model.name }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </section>
        </div>

        <!-- Heritage Section -->
        <div class="bg-black border-t-primary border-t-4 overflow-x-hidden py-10">
            <section class="relative w-full pb-3 md:pb-5 px-4 mt-10">
                <div class="max-w-7xl mx-auto text-center">
                    <p class="text-xl md:text-xl lg:text-2xl text-white uppercase tracking-wider">{{
                        heritageData?.subtitle || 'OVER THREE DECADES OF' }}</p>
                    <h1
                        class="text-4xl md:text-5xl lg:text-7xl xl:text-8xl uppercase tracking-widest leading-tight text-center font-anton">
                        @if(isScreenSmall){
                        <span class="text-white">ICONIC</span>
                        <br>
                        <span class="text-primary">HERITAGE</span>
                        }@else {
                        <span class="text-white">ICONIC </span>
                        <span class="text-primary">HERITAGE</span>
                        }
                    </h1>
                </div>
            </section>
            <section class="relative w-full pt-2 md:pt-4 pb-4 md:pb-8 px-4">
                <div class="max-w-7xl mx-auto text-center">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto mb-12">
                        @for (fact of heritageFacts; track fact.title) {
                        <div class="relative group  flex">
                            <div class="relative overflow-hidden rounded-2xl border-2 border-white flex flex-col w-full transition-transform duration-300"
                                [ngClass]="{'cursor-pointer hover:scale-105': fact.hyperlink}"
                                (click)="onHeritageCardClick(fact)">
                                <div class="relative overflow-hidden aspect-[16/10]">
                                    @if(fact?.image?.url) {
                                    <img [src]="strapiService.getFullImageUrl(fact.image.url)" [width]="800" [height]="500" [alt]="fact.title"
                                        loading="lazy" class="w-full h-full object-cover">
                                    }
                                </div>
                                <div class="bg-black p-6 md:p-8 flex-1 flex items-center justify-center">
                                    <h3 class="text-white text-lg md:text-xl lg:text-2xl font-bold uppercase tracking-wide leading-tight text-center"
                                        [innerHTML]="fact.title">
                                    </h3>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </section>
        </div>

        <landing-footer></landing-footer>
    </div>
    } @else {
    <!-- Standard Header for Non-Landing Pages -->
    <div class="sticky top-0 flex flex-col w-full z-50 print:hidden transition-all duration-300"
        id="header" [ngClass]="{
            'bg-black shadow-lg': isHeaderScrolled,
            'backdrop-blur-md bg-black/60': !isHeaderScrolled
        }">
        <ng-container *ngTemplateOutlet="siteHeaderNav"></ng-container>
    </div>

    <!-- Content -->
    <div class="flex w-full flex-col flex-auto overflow-x-clip">
        @if (memberUrl) {
        <div class="transition-all duration-300 min-h-screen overflow-x-hidden w-full bg-neutral-50 !font-inter">
            <router-outlet></router-outlet>
        </div>
        } @else {
        <router-outlet></router-outlet>
        }
        @if (!isLandingPage()) {
        <landing-footer></landing-footer>
        }
    </div>
    }

    <!-- Video Modal for Heritage Card -->
    @if (selectedVideoUrl) {
    <div class="fixed inset-0 flex items-center justify-center bg-black/90"
        style="z-index: 9999; isolation: isolate; -webkit-transform: translateZ(0); transform: translateZ(0); touch-action: none;"
        (click)="closeVideoModal()">
        <div class="relative w-full max-w-6xl mx-4" style="will-change: transform;"
            (click)="$event.stopPropagation()">
            <!-- Close Button -->
            <button (click)="closeVideoModal()"
                class="absolute -top-12 right-0 w-10 h-10 flex items-center justify-center bg-black/70 text-white rounded-full hover:bg-black/90 transition-colors duration-200"
                style="z-index: 20; -webkit-tap-highlight-color: transparent;" aria-label="Close video">
                <mat-icon class="text-white" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>

            <!-- Video Player -->
            <div class="aspect-video bg-black rounded-lg overflow-hidden">
                <iframe width="100%" height="100%" [src]="selectedVideoUrl" title="Heritage Video" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen class="w-full h-full">
                </iframe>
            </div>
        </div>
    </div>
    }

    <!-- Footer (Only for non-landing pages) -->

</div>
